//definizione delle variabili che limitano titolo e descrizione

const max_char_titolo = 200
const max_char_descrizione = 500
const max_dimensione_files = 5242880//5MB = 5*1024*1024
const max_dimensione_banner_sondaggi = 1048576 //1MB
const versione = "v.2.1.2"


export { max_char_titolo, max_char_descrizione,max_dimensione_files, versione, max_dimensione_banner_sondaggi }